var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 21,
    fill: "none",
    viewBox: "0 0 16 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#146EB4",
    fillRule: "evenodd",
    stroke: "#146EB4",
    strokeWidth: 0.6,
    d: "M9.915.593c.379 0 .758.16 1.038.439l4.371 4.371c.28.28.44.66.44 1.038V18.08c0 .818-.66 1.477-1.478 1.477H2.07c-.819 0-1.477-.659-1.477-1.477V2.069c0-.398.16-.758.439-1.037.28-.28.639-.44 1.038-.44h7.845zm-.18.858H2.07l-.08.005c-.132.017-.26.075-.36.175-.119.12-.179.28-.179.439v16.009c0 .339.28.618.619.618h12.216c.34 0 .619-.279.619-.618V6.62h-3.653c-.838 0-1.517-.679-1.517-1.517V1.451zM7.479 7.38c.36 0 .64.14.819.419.399.599.22 1.836-.16 3.134.2.359.44.698.659.938.32.32.599.618.878.858 1.637-.3 2.735-.18 3.094.38.06.1.24.478-.2.918-.299.299-.618.459-1.058.439-.578 0-1.237-.34-2.016-.958-.419.08-.898.2-1.437.359-.459.12-.878.26-1.237.4-.6 1.137-1.418 2.255-2.176 2.454-.08.02-.16.04-.24.04-.2 0-.379-.08-.539-.2-.28-.219-.379-.498-.319-.818.14-.678 1.138-1.397 2.775-2.036.16-.32.319-.659.459-.998.24-.619.439-1.178.599-1.697-.58-1.077-1.058-2.395-.739-3.114.14-.339.44-.518.838-.518zm-1.756 7.325c-.998.48-1.457.918-1.497 1.158-.02.04-.02.08.06.14.04.02.08.04.16.02.319-.08.798-.6 1.277-1.318zm6.327-1.178c.2-.239-.459-.359-1.616-.2.419.28.778.42 1.077.42.22 0 .4-.06.54-.22zM7.86 11.791c-.14.4-.3.778-.44 1.158-.06.12-.12.26-.18.399l.6-.18c.339-.1.678-.18.998-.26-.18-.179-.36-.359-.54-.558-.139-.14-.279-.34-.438-.56zm-.38-3.713c-.16 0-.18.06-.2.1-.139.32.04 1.038.38 1.796.22-.878.24-1.537.06-1.796-.04-.04-.1-.1-.24-.1zm3.114-6.188v3.214c0 .36.3.659.659.659h3.234L10.593 1.89z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V20.148H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdfIcon.da5c31aa99ac8aa9b4edcf23fe788c89.svg";
export { ForwardRef as ReactComponent };